import getDefaultOpts from "@/store/utils/getDefaultOpts.js";
import { updateHomeButtonMedia } from "@/util/patchMediaHelpers.js";

function normalizeButtonData(homeButtons) {
  return homeButtons.map((button) => {
    switch (button.type) {
      case "Text":
        if (
          button.data &&
          typeof button.data === "object" &&
          "text" in button.data
        ) {
          return {
            ...button,
            data: button.data.text,
          };
        }
        return button;
      default:
        return button;
    }
  });
}

/*
This action will write home button data to the API as well as update it in Vuex.
 */
async function saveHomeButtonData(module, { value, opts = {} }) {
  const { dispatch } = module;
  const config = Object.assign(getDefaultOpts(), opts);
  const dataKey = ["Home", "styling", "homeButtons", "homeButtons"];
  const copy = JSON.parse(JSON.stringify(value));

  // legacy: get rid of the `id` property
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const homeButtons = copy.map(({ id, ...rest }) => rest);

  await dispatch(
    "setStoreVar",
    {
      page: dataKey[0],
      group: dataKey[1],
      type: dataKey[2],
      name: dataKey[3],
      value,
    },
    { root: true }
  );

  const normalizedHomeButtons = normalizeButtonData(homeButtons);

  return dispatch("patchSite", {
    patch: {
      homeButtons: updateHomeButtonMedia(normalizedHomeButtons),
    },
    config,
  });
}

export { saveHomeButtonData };
